export const SET_DATA = "@DASHBOARD/SET_DATA";
export const READ = "@DASHBOARD/READ";
export const READ_FAIL = "@DASHBOARD/READ_FAIL";
export const READ_SUCCESS = "@DASHBOARD/READ_SUCCESS";
export const REQUEST_READ = "@DASHBOARD/REQUEST_READ";
export const CHANGE_BUTTON_SELECTED = "@DASHBOARD/CHANGE_BUTTON_SELECTED";
